export const CAN_ADD_PROJECT = 'CAN_ADD_PROJECT';
export const CAN_EDIT_PROJECT = 'CAN_EDIT_PROJECT';
export const CAN_ARCHIVE_PROJECT = 'CAN_ARCHIVE_PROJECT';
export const CAN_VIEW_PROJECT = 'CAN_VIEW_PROJECT';
export const CAN_SEARCH_PROJECT = 'CAN_SEARCH_PROJECT';
export const CAN_CREATE_EPIC = 'CAN_CREATE_EPIC';
export const CAN_EDIT_EPIC = 'CAN_EDIT_EPIC';
export const CAN_ADD_ESTIMATE = 'CAN_ADD_ESTIMATE';
export const CAN_EDIT_ESTIMATE = 'CAN_EDIT_ESTIMATE';
export const CAN_ADD_TEAM_MEMBERS = 'CAN_ADD_TEAM_MEMBERS';
export const CAN_EDIT_TEAM_MEMBERS = 'CAN_EDIT_TEAM_MEMBERS';
export const CAN_SET_PRIORITIES = 'CAN_SET_PRIORITIES';
export const CAN_ADD_TIMEBLOCK = 'CAN_ADD_TIMEBLOCK';
